export default "__VITE_ASSET__Ci6Zwswx__"